
import { Component, Prop, Vue } from 'vue-property-decorator'
import { DNSRecordsInterface } from '@/services/DNS/Interfaces'

@Component
export default class DeleteDnsRecordDialog extends Vue {
  @Prop() private readonly record!: DNSRecordsInterface
  @Prop() private readonly onDelete!: CallableFunction

  private visible: boolean = true

  get message(): string {
    console.log(this.record);
    return `Are you sure you want to remove ${this.record.content.host}(${this.record.type}: ${this.record.target})?`
  }

  private destroyComponent(): void {
    this.$emit('close')
  }

  private async deleteRecord(): Promise<void> {
    await this.onDelete(this.record)
    this.destroyComponent()
  }
}
